<div [style.position]="'relative'" [style.cursor]="showMaskedSIN ? 'not-allowed' : 'pointer'">
  <input
    *ngIf="!showMaskedSIN"
    class="sin-input"
    type="text"
    inputmode="text"
    autocomplete="off"
    [attr.id]="controlId"
    [placeholder]="placeholder"
    [maskito]="maskOptions"
    [value]="value"
    [disabled]="disabled"
    [ngClass]="{
      'error-border': error
    }"
    (input)="handleInput($event)"
    (blur)="handleBlur()" />

  <div
    [hidden]="!showMaskedSIN"
    class="sin-input sin-input-hidden"
    [attr.contenteditable]="false"
    [innerHTML]="hiddenSINHtml"
    [ngClass]="{
      'error-border': error,
      disabled: disabled
    }"
    [ngStyle]="{ 'padding-right': showHideSINButton ? '2rem' : '0' }"></div>
  <button
    class="base-eye black-eye"
    [attr.aria-label]="showingSIN ? hideSINLabel : showSINLabel"
    (mousedown)="keepInputFocus($event)"
    (click)="toggleShowHide()"
    [disabled]="disabled"
    type="button"
    [ngClass]="{ opened: showingSIN, closed: !showingSIN, error: error, disabled: disabled }"></button>
</div>
